import(/* webpackMode: "eager", webpackExports: ["LegalPageTitle","LegalNavLinks"] */ "/home/pi/prod/strawman/apps/web/app/(landing)/[legal]/LegalNav.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/app/(landing)/[legal]/style.css");
